// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Js_int from "@rescript/std/lib/es6/js_int.js";
import * as Context from "../../provider/Context.bs.js";
import * as UseRefs from "../../hook/UseRefs.bs.js";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as SetFocus from "../../hook/SetFocus.bs.js";
import * as Util_Dom from "../../util/Util_Dom.bs.js";
import * as Atom_Cell from "../atom/Atom_Cell.bs.js";
import * as Atom_Grid from "../atom/Atom_Grid.bs.js";
import * as Atom_Text from "../atom/Atom_Text.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../type/Type_String.bs.js";
import * as UseNextPage from "../../hook/UseNextPage.bs.js";
import * as Atom_Text_Ds from "../atom/Atom_Text_Ds.bs.js";
import * as Atom_Image_Ds from "../atom/Atom_Image_Ds.bs.js";
import * as UsePagination from "../../hook/UsePagination.bs.js";
import * as Organism_Teaser from "../organism/teaser/Organism_Teaser.bs.js";
import * as Particle_zIndex from "../particle/Particle_zIndex.bs.js";
import * as Organism_Teaser_Ds from "../organism/teaser/Organism_Teaser_Ds.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";
import * as Organism_Teaser_Css_Identifier from "../organism/teaser/Organism_Teaser_Css_Identifier.bs.js";
import * as Molecule_PaginatedGrid_Constant from "./Molecule_PaginatedGrid_Constant.bs.js";

var gridGap = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M");

function makeBy(lastPage, maxPage, step, getPageUrl, pageUrl) {
  return Belt_Array.reduce(Belt_Array.rangeBy(0, Math.min(maxPage, lastPage), step), [], (function (acc, page) {
                var match = Curry._2(getPageUrl, pageUrl, page);
                if (page !== 0 && match !== undefined) {
                  acc.push(React.createElement(Atom_Cta.Seo.make, {
                            href: match,
                            label: ""
                          }));
                  return acc;
                } else {
                  return acc;
                }
              }));
}

function makeFirstNinePageLinks(lastPage, pageUrl, getPageUrl) {
  return makeBy(lastPage, 9, 1, getPageUrl, pageUrl);
}

function makeTensPageLink(lastPage, pageUrl, getPageUrl) {
  return makeBy(lastPage, 99, 10, getPageUrl, pageUrl);
}

function makeHundredsPageLink(lastPage, pageUrl, getPageUrl) {
  return makeBy(lastPage, Js_int.max, 100, getPageUrl, pageUrl);
}

var SEO = {
  makeBy: makeBy,
  makeFirstNinePageLinks: makeFirstNinePageLinks,
  makeTensPageLink: makeTensPageLink,
  makeHundredsPageLink: makeHundredsPageLink
};

function Molecule_PaginatedGrid(Props) {
  var id = Props.id;
  var title = Props.title;
  var seeMoreLabel = Props.seeMoreLabel;
  var zone = Props.zone;
  var blockSpace = Props.blockSpace;
  var url = Props.url;
  var ref_ = Props.ref_;
  var match = Context.Config.getState(undefined);
  var totalPagesCount = zone.totalPagesCount;
  var lastPage = zone.lastPage;
  var nextPage = zone.nextPage;
  var teasers = zone.data;
  var api = match.api;
  var getPageUrl = api.getPageUrl;
  var getNextPageUrl = api.getNextPageUrl;
  var initialNextPage;
  if (nextPage !== undefined) {
    var exit = 0;
    switch (nextPage.TAG | 0) {
      case /* Club */1 :
          initialNextPage = undefined;
          break;
      case /* Emac */0 :
      case /* EmacV4 */2 :
          exit = 1;
          break;
      
    }
    if (exit === 1) {
      initialNextPage = url !== undefined ? Curry._2(getNextPageUrl, url, nextPage._0) : undefined;
    }
    
  } else {
    initialNextPage = undefined;
  }
  var initialLastPage = lastPage !== undefined && url !== undefined ? Curry._2(getNextPageUrl, url, lastPage) : undefined;
  var match$1 = Atom_Image_Ds.view(Atom_Image_Ds.make(/* StandardTeaser */15));
  var size = match$1.size;
  var match$2 = Particle_Screen_Ds.getValueByScreenSize({
        NAME: "XS",
        VAL: undefined
      }, size);
  var match$3;
  if (match$2 !== undefined && typeof match$2 === "object" && match$2.NAME === "Custom") {
    var match$4 = match$2.VAL;
    match$3 = [
      match$4[0],
      match$4[1]
    ];
  } else {
    match$3 = [
      0,
      0
    ];
  }
  var match$5 = Particle_Screen_Ds.getValueByScreenSize({
        NAME: "M",
        VAL: undefined
      }, size);
  var match$6;
  if (match$5 !== undefined && typeof match$5 === "object" && match$5.NAME === "Custom") {
    var match$7 = match$5.VAL;
    match$6 = [
      match$7[0],
      match$7[1]
    ];
  } else {
    match$6 = [
      0,
      0
    ];
  }
  var match$8 = UseRefs.make(undefined);
  var setRef = match$8[1];
  var getRef = match$8[0];
  var match$9 = React.useState(function () {
        
      });
  var setChunkIdToFocus = match$9[1];
  var chunkIdToFocus = match$9[0];
  var async = UseNextPage.make2(zone);
  var previousChunksCount = React.useRef(0);
  var match$10 = UsePagination.use(UsePagination.makeConfig(async, Molecule_PaginatedGrid_Constant.elementsPerChunk, {
            TAG: /* NumberElement */0,
            _0: teasers.length
          }, undefined), teasers);
  var chunks = match$10.data;
  var status = match$10.status;
  var loadMore = match$10.loadMore;
  React.useEffect((function () {
          var exit = 0;
          if (status !== 2) {
            if (status >= 5 && chunks.length !== 1) {
              exit = 1;
            }
            
          } else if (chunks.length !== 1) {
            exit = 1;
          }
          if (exit === 1) {
            var newChunkId = Belt_Option.map(Belt_Array.get(chunks, previousChunksCount.current), (function (param) {
                    return param.id;
                  }));
            Curry._1(setChunkIdToFocus, (function (param) {
                    return newChunkId;
                  }));
          }
          previousChunksCount.current = chunks.length;
        }), [
        status,
        chunks
      ]);
  var handleClick = function (param) {
    Curry._1(loadMore, undefined);
  };
  var gridRules = Particle_Screen_Ds.make(undefined, undefined, [CssJs.gridTemplateColumns([{
                NAME: "repeat",
                VAL: [
                  "autoFit",
                  {
                    NAME: "minmax",
                    VAL: [
                      CssJs.px(match$6[0]),
                      CssJs.maxContent
                    ]
                  }
                ]
              }])], undefined, undefined, [CssJs.gridTemplateColumns([{
                NAME: "repeat",
                VAL: [
                  "autoFit",
                  {
                    NAME: "minmax",
                    VAL: [
                      CssJs.px(match$3[0]),
                      CssJs.maxContent
                    ]
                  }
                ]
              }])]);
  var teasers$1 = React.useMemo((function () {
          return Belt_Array.map(chunks, (function (teaser) {
                        var ref = Curry._1(setRef, Curry._1(Type_String.Teaser.Id.toString, teaser.id));
                        return React.createElement(Organism_Teaser.make, {
                                    style: Organism_Teaser_Ds.classic(/* StandardTeaser */15),
                                    teaser: teaser,
                                    teaserRef: ref,
                                    key: Curry._1(Type_String.Teaser.Id.toString, teaser.id)
                                  });
                      }));
        }), [
        chunks,
        zone.itemTitle,
        /* StandardTeaser */15,
        setRef
      ]);
  React.useEffect((function () {
          SetFocus.setFocus(Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.map(chunkIdToFocus, Type_String.Teaser.Id.toString), getRef), Util_Dom.getFirstElementFocusable));
        }), [chunkIdToFocus]);
  var wrapperRules = Particle_Screen_Ds.make(undefined, undefined, [Organism_Teaser_Css_Identifier.Selectors.teaserImageSelector([CssJs.minHeight(CssJs.px(match$6[1]))])], undefined, undefined, [
        Particle_zIndex.Particle_zIndex_Css.toCss({
              TAG: /* Exact */0,
              _0: /* PaginatedGrid */10
            }),
        Organism_Teaser_Css_Identifier.Selectors.teaserItemsSelector([CssJs.width(CssJs.pct(100))]),
        Organism_Teaser_Css_Identifier.Selectors.teaserImageSelector([
              CssJs.width(CssJs.pct(100)),
              CssJs.height(CssJs.pct(100)),
              CssJs.minHeight(CssJs.px(match$3[1]))
            ])
      ]);
  var seeMoreButton = status !== 2 ? React.createElement(Atom_Cell.make, {
          alignSelf: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
          children: React.createElement(Atom_Cta.Button.make, {
                identifier: Molecule_PaginatedGrid_Constant.seeMoreButtonIdentifier,
                label: seeMoreLabel,
                onClick: handleClick,
                style: /* SeeMore */20
              })
        }) : null;
  var tmp = {
    children: null,
    id: id,
    innerSpace: Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS"),
    rules: wrapperRules,
    width: Particle_Screen_Constants.oneHundredPctWidth
  };
  if (blockSpace !== undefined) {
    tmp.blockSpace = Caml_option.valFromOption(blockSpace);
  }
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Column.make, tmp, title !== undefined ? React.createElement(Atom_Text.make, {
                    children: title,
                    kind: "h2",
                    style: Atom_Text_Ds.makePaginatedGrid
                  }) : null, React.createElement(Atom_Grid.make, {
                  children: teasers$1,
                  gap: gridGap,
                  rules: gridRules
                }), seeMoreButton, totalPagesCount !== undefined && url !== undefined ? React.createElement(React.Fragment, undefined, makeFirstNinePageLinks(totalPagesCount, url, getPageUrl), makeTensPageLink(totalPagesCount, url, getPageUrl), makeHundredsPageLink(totalPagesCount, url, getPageUrl)) : null, initialNextPage !== undefined ? React.createElement(Atom_Cta.Seo.make, {
                    href: initialNextPage,
                    label: "Next"
                  }) : null, initialLastPage !== undefined ? React.createElement(Atom_Cta.Seo.make, {
                    href: initialLastPage,
                    label: "Last"
                  }) : null);
}

var make = Molecule_PaginatedGrid;

export {
  gridGap ,
  SEO ,
  make ,
}
/* gridGap Not a pure module */
